import { render, staticRenderFns } from "./select-entrusted.vue?vue&type=template&id=008e0623&scoped=true"
import script from "./select-entrusted.vue?vue&type=script&lang=ts"
export * from "./select-entrusted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e0623",
  null
  
)

export default component.exports